import { Directive, OnInit, Renderer2 } from '@angular/core';
import { ScreenSizeService } from '../services/screen-size.service';
import { EventsService } from '../services/events.service';
import {
  HEADER_MENU_OPENED,
  HEADER_MENU_CLOSED,
  SCREEN_SIZE_WAS_CHANGED
} from '../../app.constants';

@Directive({
  selector: '[scrollControl]'
})
export class ScrollControlDirective implements OnInit {

  private subscriptions = [];

  constructor (
    private render: Renderer2,
    private eventBus: EventsService,
    private screenSizeService: ScreenSizeService
  ) {}

  ngOnInit () {
    this.activate();

    this.eventBus
      .on(SCREEN_SIZE_WAS_CHANGED)
      .subscribe(() => this.activate());
  }

  activate () {
    const isMobile = !this.screenSizeService.isLarge();

    if (!isMobile && this.subscriptions.length) {
      this.unsubscribeOnMenuChanges();
    }

    if (isMobile && !this.subscriptions.length) {
      this.subscribeOnMenuChanges();
    }
  }

  subscribeOnMenuChanges () {
    const hideSub = this.eventBus.on(HEADER_MENU_OPENED).subscribe(() => this.hideScroll());
    const showSub = this.eventBus.on(HEADER_MENU_CLOSED).subscribe(() => this.showScroll());

    this.subscriptions.push(hideSub);
    this.subscriptions.push(showSub);
  }

  unsubscribeOnMenuChanges () {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.subscriptions.length = 0;
  }

  hideScroll () {
    this.render.addClass(document.body, 'hide-scroll');
  }

  showScroll () {
    this.render.removeClass(document.body, 'hide-scroll');
  }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/core/directives/scroll-controll.directive.ts